if (!customElements.get('sticky-atc-panel')) {
  class StickyAtcPanel extends HTMLElement {
    constructor() {
      super();

      this.productSection = this.closest('.cc-main-product');
      this.productInfo = this.productSection.querySelector('.product-info');
      this.productForm = this.productSection.querySelector('product-form');

      if ('IntersectionObserver' in window && 'MutationObserver' in window) {
        this.bindEvents();
      }
    }

    // eslint-disable-next-line class-methods-use-this
    disconnectedCallback() {
      window.removeEventListener('scroll', StickyAtcPanel.handleScroll);
    }

    bindEvents() {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.target === this.addButton && !theme.mediaMatches.md) {
            // FSD 2026-10-07: on phones the bar shows whenever the main Add to cart button is off-screen,
            // above it (first screen) or below it (reading the description), and hides while it is visible.
            this.classList.toggle('sticky-atc-panel--out', entry.isIntersecting);
          } else if (entry.target === this.productInfo && theme.mediaMatches.md) {
            this.classList.toggle('sticky-atc-panel--out', entry.isIntersecting);
          }
        });
      });

      this.addButton = this.productSection.querySelector('.product-info__add-button') || this.productForm;
      if (this.addButton) observer.observe(this.addButton);
      this.querySelectorAll('[data-fsd-sticky-add]').forEach((btn) => btn.addEventListener('click', () => {
        const main = this.productSection.querySelector('.product-info__add-button button[name="add"], product-form button[name="add"]');
        if (main && !main.disabled) { main.click(); } else { const v = this.productSection.querySelector('#variants, .product-options'); if (v) v.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
      }));
      if (this.productInfo) observer.observe(this.productInfo);

      window.addEventListener('scroll', StickyAtcPanel.handleScroll);
    }

    /**
     * Watches for a scroll to the bottom of the page
     */
    static handleScroll() {
      document.body.classList.toggle(
        'scrolled-to-bottom',
        window.scrollY + window.innerHeight + 100 > document.body.scrollHeight
      );
    }
  }

  customElements.define('sticky-atc-panel', StickyAtcPanel);
}

